module.exports = __webpack_public_path__ + "img/h5-通用素质.ef4be302.svg";